import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CourseProp from './propTypes/courseProp';
import AcademyList from './list/AcademyList';
import AcademyEnrolledCourses from './list/AcademyEnrolledCourses';
import CategoryProp from './propTypes/categoryProp';
import translate from '../../commonComponents/translate';
import AcademyFilters from './list/AcademyFilters';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import CourseTagProp from '../../commonComponents/propTypes/CourseTagProp';
import { useScrollAnchor } from '../../services/customHooks';
import PriceRangeProp from './propTypes/PriceRangeProp';

function Academy(props) {
  const {
    t,
    enrolledCourses,
    categories,
    languages,
    currencies,
    skills,
    tags,
    applyFilters,
    priceRange,
  } = props;
  const { contentElement, scrollToContent } = useScrollAnchor();

  const [query, setQuery] = useState({
    category: '',
    language: '',
    certificate: undefined,
    price: priceRange.max,
    hardSkill: '',
    tags: '',
    search: '',
  });
  const handleQueryChange = value => {
    setQuery(q => ({ ...q, ...value }));
    scrollToContent();
  };
  const handleChange = field => value => {
    setQuery(q => ({ ...q, [field]: value }));
    scrollToContent();
  };
  const hasEnrolledCourses = enrolledCourses && enrolledCourses.length > 0;

  /** Set State = localStorage */
  useEffect(() => {
    // if redirect is with ?applyFilters=true, apply filters
    if (applyFilters) {
      if (localStorage.getItem('coursesFilter') && localStorage.getItem('coursesFilter').length > 0) {
        setQuery(JSON.parse(localStorage.getItem('coursesFilter')));
      }
    } else {
      localStorage.removeItem('coursesFilter');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('coursesFilter', JSON.stringify(query));
  }, [query]);

  return (
    <>
      {hasEnrolledCourses && (
        <>
          <AcademyEnrolledCourses courses={enrolledCourses} />
          <div className="academy-subtitle">
            <h3 className="academy-subtitle-title">
              {t('academy_availableCourses')}
            </h3>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-lg-3 filters-shop-desktop">
          <AcademyFilters
            currencies={currencies}
            languages={languages}
            categories={categories}
            skills={skills}
            tags={tags}
            selected={query}
            onChange={handleQueryChange}
            onPriceChange={handleChange}
            priceRange={priceRange}
          />
        </div>
        <div className="col-lg-9" ref={contentElement}>
          <AcademyList
            languages={languages}
            query={query}
            onChange={handleChange}
            onQueryChange={handleQueryChange}
            tags={tags}
            currencies={currencies}
            categories={categories}
            priceRange={priceRange}
            skills={skills}
          />
        </div>
      </div>
    </>
  );
}

Academy.propTypes = {
  t: PropTypes.func.isRequired,
  enrolledCourses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)),
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  skills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType)).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

Academy.defaultProps = {
  enrolledCourses: null,
  tags: [],
  applyFilters: false,
};

export default translate(Academy);
